// Canonical event-status labels — keeps display names consistent across all pages.
// DB values: draft, pending_payment, active, live, completed, cancelled
const STATUS_LABELS = {
  draft:           'Draft',
  pending_payment: 'Pending Payment',
  active:          'Not Started',
  live:            'Live',
  completed:       'Final Official',
  cancelled:       'Cancelled',
};

export function eventStatusLabel(status) {
  return STATUS_LABELS[status] || status;
}
